import React, { Component } from 'react';
import {Header, Banner, Chapter, About, Features, Feature2,
    Cta, Author,Review,Pricing,Contact,Footer,VideoSection} from '../layouts/es/index';

class Home04 extends Component {
    render() {
        return (
            <div className="dark-theme">       
                <Header />       
                        <Banner />
                        <Feature2 />
                        <VideoSection />
                        <About />
                        <Features />
                        <Chapter />
                        {/*<Cta />*/}
                        {/*<Review />*/}
                        <Author />
                        {/*<Pricing />*/}
                        <Contact />
                {/*<Footer />*/}
            </div>
        );
    }
}

export default Home04;
